module.exports = __webpack_public_path__ + "static/media/wilson-tsai@2x.46728b50.png";